import script from "./type_cctv.vue?vue&type=script&setup=true&lang=js"
export * from "./type_cctv.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__